import { render, staticRenderFns } from "./SalesPriceRange.vue?vue&type=template&id=6ddd1ef3&scoped=true"
import script from "./SalesPriceRange.vue?vue&type=script&lang=js"
export * from "./SalesPriceRange.vue?vue&type=script&lang=js"
import style0 from "./SalesPriceRange.vue?vue&type=style&index=0&id=6ddd1ef3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ddd1ef3",
  null
  
)

export default component.exports